
export { ShoppingBagButton } from "/codebuild/output/src2410076634/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"